export const SOP_FORCE_REFRESH_EVENT = 'sop:force-refresh';
